import { lectriumUrlsPatterns } from './constants'

export function isLectriumIframe(iframe: HTMLIFrameElement): boolean {
  const src = iframe.src || ''
  const result = lectriumUrlsPatterns.some(urlPattern => src.includes(urlPattern))
  return result
}

export function findLectriumIframes(): HTMLIFrameElement[] {
  const iframes = Array.from(document.getElementsByTagName('iframe'))
  const filtered = iframes.filter(iframe => isLectriumIframe(iframe))
  return filtered
}

function hasIframes(nodeList: NodeList): boolean {
  return Array.from(nodeList).some(node => {
    if (node instanceof HTMLIFrameElement || node.nodeName === 'IFRAME') {
      return true
    }
    if (node instanceof Element) {
      return node.getElementsByTagName('iframe').length > 0
    }
    return false
  })
}

export function onIframesChanged(callback: () => void): MutationObserver {
  const observer = new MutationObserver(mutationsList => {
    let hasChanged = false
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        if (mutation.target.nodeName !== 'IFRAME') continue
        hasChanged = true
        break
      }
      const isIframeRelated = hasIframes(mutation.addedNodes) || hasIframes(mutation.removedNodes)
      if (isIframeRelated) {
        hasChanged = true
        break
      }
    }
    if (hasChanged) {
      callback()
    }
  })

  // A src change can move an iframe to another origin, which needs a new Penpal connection.
  const config: MutationObserverInit = { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] }
  observer.observe(document.documentElement, config)
  return observer
}
